module.exports = __webpack_public_path__ + "img/toggle-left.8930139f.svg";